var map = {
	"./X33-Mall_small.jpg": 903,
	"./all-active.svg": 904,
	"./all.svg": 905,
	"./apple-watch.png": 906,
	"./b-headphone.png": 907,
	"./coin.svg": 908,
	"./delete-btn.svg": 909,
	"./iphone-13.webp": 2305,
	"./iphone-pink.png": 910,
	"./love-active.svg": 911,
	"./love.svg": 912,
	"./mobile-bg.jpg": 913,
	"./mobile-bg.webp": 2306,
	"./price-high-active.svg": 914,
	"./price-high.svg": 915,
	"./price-low-active.svg": 916,
	"./price-low.svg": 917,
	"./rewards-dnp-cn.webp": 2307,
	"./rewards-dnp.webp": 2308,
	"./shopping-cart.svg": 918,
	"./star.svg": 919,
	"./x33mall-banner-cn.jpg": 920,
	"./x33mall-banner-cn.webp": 2309,
	"./x33mall-banner-id.jpg": 921,
	"./x33mall-banner-ms.jpg": 922,
	"./x33mall-banner-ms.webp": 2310,
	"./x33mall-banner.jpg": 923,
	"./x33mall-banner.webp": 2311
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 925;